async function getDomContentAsync(getContent: () => HTMLElement | null): Promise<HTMLElement> {
  let element = getContent();
  if (element) return element;
  if (document.readyState === 'loading') {
    await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve, false));
  }
  element = getContent();
  if (element) return element;
  throw new Error(`failed to get DOM content`);
}

export const getElementByIdAsync = (id: string) =>
  getDomContentAsync(() => document.getElementById(id)).catch(() => {
    throw new Error(`failed to get element by id "${id}"`);
  });

export const querySelectorAsync = (selector: string) =>
  getDomContentAsync(() => document.querySelector(selector)).catch(() => {
    throw new Error(`failed to find element with selector "${selector}"`);
  });
